import React, { useState, useEffect } from "react";
import gql from "graphql-tag";
import { useApolloClient } from "@apollo/react-hooks";
import { Accordion, Card, Button } from "react-bootstrap";
import MachineDetails from "./components/MachineDetails";

import MachineManufacturing from "./components/MachineManufacturing";
import PowderMfg from "./components/PowderMfg";
import InertGas from "./components/InertGas";
import ElectricityConsumption from "./components/ElectricityConsumption";
import Transportation from "./components/Transportation";
import PostProcessing from "./components/PostProcessing";
import WastePowder from "./components/WastePowder";
import CarbonContentPerPart from "./components/CarbonContentPerPart";
import ArrowDown from "./components/ArrowDown";
import { Spinner } from "react-bootstrap";
import { useRecoilState, useRecoilValue } from "recoil";
import { ProcessFlag } from "atoms/General/index.js";
import { technologyId, stepTypeId, technologyType } from "atoms/General";
import { ToastContainer, toast } from "react-toastify";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { GET_CLIENT_STEPS } from "./components/getStepDetail";

const ProcessMetal = ({ ScenarioState, socket }) => {
  // const [socket, setSocket] = useState()

  // useEffect(() => {
  //     const socketOb = new socketIOClient(constant.uri);
  //     const patch = require('socketio-wildcard')(socketIOClient.Manager);
  //     patch(socketOb)
  //     const socketObj = socketOb
  //     setSocket(socketObj)
  // }, [])

  const client = useApolloClient();
  const [clientSteps, setClientSteps] = useState([]);
  const [loader, setLoader] = useState(true);
  const [techId, setTechId] = useRecoilState(technologyId);
  const [steptypeId, setStepTypeId] = useRecoilState(stepTypeId);
  const [TechnologyType, settechnologyType] = useRecoilState(technologyType);
  const processFlag = useRecoilValue(ProcessFlag);

  useEffect(() => {
    setTechId(1);
    setStepTypeId(3);
    settechnologyType("CO2e Metal");

    client
      .query({
        query: GET_CLIENT_STEPS,
        variables: { technology_id: 1, type_id: 3 },
      })
      .then(({ data, loading }) => {
        setClientSteps(data.getClientSteps);
        // console.log(data.getClientSteps);
        setLoader(false);
      })
      .catch((error) => {
        console.log("error in process", error);
        // toast.error(error.graphQLErrors[0].messasge.message)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const [activeState, setActiveState] = useState(-1);
  const toggleState = (idnum) => {
    const id = idnum;
    if (activeState === +id) {
      setActiveState(null);
    } else {
      setActiveState(+id);
    }
  };
  return (
    <>
      {loader ? (
        <div className="d-flex justify-content-center align-items-center pt-5">
          <Spinner animation="border" />{" "}
        </div>
      ) : (
        <>
          <Accordion>
            {clientSteps &&
              clientSteps.map((step, index) => {
                return (
                  <div className="mb-40">
                    {step?.step_id === 49 && (
                      <>
                        <div className="table-title-border mb-24">
                          <span className="font-24 font-semi-bold">
                            Machine Details{" "}
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-20 ">
                          <MachineDetails StepID={49} Socket={socket} />
                        </div>
                      </>
                    )}
                    {step?.step_id === 50 &&
                      processFlag.MachineManufacturing && (
                        <MachineManufacturing StepID={50} Socket={socket} />
                      )}
                    {step?.step_id === 51 && processFlag.MachineDetails && (
                      <>
                        <div className="table-title-border mb-24">
                          <span className="font-24 font-semi-bold">
                            Powder Manufacturing{" "}
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-20 ">
                          <PowderMfg Socket={socket} />
                        </div>
                      </>
                    )}
                    {step?.step_id === 52 &&
                      processFlag.PowderManufacturing && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">
                              Inert Gas{" "}
                            </span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <InertGas Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 53 && processFlag.InertGas && (
                      <>
                        <div className="table-title-border mb-24">
                          <span className="font-24 font-semi-bold">
                            Electricity Consumption
                          </span>
                        </div>
                        <div className="d-flex flex-wrap gap-20 ">
                          <ElectricityConsumption Socket={socket} />
                        </div>
                      </>
                    )}
                    {step?.step_id === 54 &&
                      processFlag.ElectricityConsumption && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">
                              Logistics{" "}
                            </span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <Transportation Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 55 && processFlag.PostProcessing && (
                      <>
                        <PostProcessing Socket={socket} />
                      </>
                    )}
                    {step?.step_id === 56 && processFlag.WastePowder && (
                      <>
                        <WastePowder Socket={socket} />
                      </>
                    )}
                    {/* {step?.step_id === 57 &&
            (processFlag.Transportation ? (
              <CarbonContentPerPart Socket={socket} />
            ) : (
              <p>Add all Transportation details to view</p>
            ))} */}
                  </div>
                );
              })}
          </Accordion>
          <div style={{ width: "inherit" }}>
            <div className="d-flex justify-content-center pt-1 w-75 flex-column">
              <p className="f-14 mb-24">
                Please note that the EOS Cost and Carbon Calculator provides
                only rough estimates. EOS assumes no liability for the
                information from this tool. For precise and reliable values,
                please consult with Additive Minds at EOS. Please see the Data
                Matrix to understand the basis for the calculation of the EOS
                Cost & Carbon Calculator.
              </p>
            </div>
            {/* <button
              onClick={() => {
                if (processFlag.Transportation) {
                  ScenarioState();
                } else {
                  toast.error("Please fill all process details.");
                }
              }}
              className="button1 button btn-primary"
            >
              Proceed
            </button> */}
           
          </div>
        </>
      )}
    </>
  );
};

export default ProcessMetal;
